import { Coffee, Zap, Radio, Cpu } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { stories } from "../../data/portfolioData";

const STORY_ICON = {
    "trojan-room": Coffee,
    "cmu-coke": Cpu,
    "cosmic-glitch": Zap,
    "wifi-blackhole": Radio,
};

export const StoriesSection = () => {
    return (
        <section
            id="stories"
            data-testid="stories-section"
            className="relative scroll-mt-24 px-6 py-24 md:px-12 md:py-32 lg:px-16"
        >
            <div className="mx-auto max-w-7xl">
                <SectionHeading
                    index="05"
                    kicker="Stories · Experiments"
                    title="Stories, experiments &amp; weird tech history."
                    subtitle="I like finding the strange human stories behind technology — the coffee pot that became a webcam, the Coke machine that became an internet legend, the bugs that quietly shaped modern computing."
                />

                <div className="grid grid-cols-1 gap-6 md:grid-cols-2 md:gap-8">
                    {stories.map((s, idx) => {
                        const Icon = STORY_ICON[s.id] || Cpu;
                        return (
                            <article
                                key={s.id}
                                data-testid={`story-card-${s.id}`}
                                className="group relative overflow-hidden rounded-xl border border-[var(--ink-border)] bg-[var(--ink-surface)] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-ink-cyan/30 md:p-8"
                            >
                                <div className="absolute right-6 top-6 font-mono text-[40px] font-light leading-none text-[var(--ink-border-strong)] transition-colors group-hover:text-ink-cyan/30 md:text-[56px]">
                                    {String(idx + 1).padStart(2, "0")}
                                </div>

                                <div className="mb-5 inline-flex h-10 w-10 items-center justify-center rounded-md border border-[var(--ink-border)] bg-[var(--ink-surface-muted)] text-ink-cyan">
                                    <Icon className="h-5 w-5" />
                                </div>

                                <h3 className="text-lg font-medium text-[var(--ink-text-primary)] md:text-xl">
                                    {s.title}
                                </h3>

                                <p className="mt-3 max-w-md text-sm leading-relaxed text-[var(--ink-text-secondary)]">
                                    {s.blurb}
                                </p>

                                <div className="mt-6 flex items-center justify-between border-t border-[var(--ink-border)] pt-4">
                                    <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--ink-text-secondary)]">
                                        {s.meta}
                                    </span>
                                    <span className="font-mono text-[11px] text-[var(--ink-text-secondary)] transition-colors group-hover:text-ink-cyan">
                                        coming soon →
                                    </span>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default StoriesSection;
